/**
 * NIAMAL × ATHENA LUXURY PERFUME APP CONTROLLER (INDIA EDITION)
 * 1. Product Database & Multi-Size Pricing
 * 2. Real-time Cart Management & Free Pan-India Delivery Tracker
 * 3. Persistent LocalStorage Wishlist
 * 4. Interactive PDP Quick-View Modal & Size Selector
 * 5. Instant Search & Faceted Category Filter Engine
 * 6. India-Specific Checkout Flow (UPI / Cards / NetBanking / COD + Pincode Auto-Lookup)
 * 7. Device Viewport Toggle (iPhone 16 Pro Mockup vs Full Responsive Web App)
 */

(function() {
  'use strict';

  // Master Formulation Catalog for Niamal (All standard 50ml bottles priced at ₹799)
  const ATHENA_CATALOG = {
    layali: {
      id: 'layali',
      title: 'Layali Eau de Parfum',
      subtitle: 'Eau de Parfum • 50ml',
      arabic: 'نيمال • ليالي',
      family: 'Smoky Amber • 28% Extrait',
      tag: 'Best Seller',
      rating: '4.8',
      reviewsCount: 230,
      basePrice: 799,
      mrp: 999,
      sizes: {
        '30ml': 499,
        '50ml': 799,
        '100ml': 1299
      },
      category: ['unisex', 'best_sellers', 'for_women'],
      scentFamily: ['floral', 'amber', 'woody'],
      notes: {
        top: 'Taif Rose Damascena, Persian Saffron, Bergamot Dew',
        heart: 'Smoked Ambergris, Night-Blooming Jasmine, Atlas Cedarwood',
        base: '20-Yr Aged Wild Hindi Oud, Sandalwood, Cashmere Musk'
      },
      description: 'A commanding presence felt the moment you enter the room, and an intimate memory that lingers on silk long after you depart. Crafted with high oil concentration for enduring sillage in the Indian climate.',
      image: 'niamal-layali-eau-de-parfum-main-packshot-800w.webp'
    },
    amber: {
      id: 'amber',
      title: 'Amber Al Oud Eau de Parfum',
      subtitle: 'Eau de Parfum • 50ml',
      arabic: 'نيمال • أمير العود',
      family: 'Resinous Woods • High Sillage',
      tag: 'Royal Warmth',
      rating: '4.9',
      reviewsCount: 198,
      basePrice: 799,
      mrp: 999,
      sizes: {
        '30ml': 499,
        '50ml': 799,
        '100ml': 1299
      },
      category: ['unisex', 'for_men', 'best_sellers'],
      scentFamily: ['amber', 'woody', 'spicy'],
      notes: {
        top: 'Sun-Drenched Cistus Labdanum, Seville Orange, Green Cardamom',
        heart: 'Molten Benzoin Resin, Honeyed Golden Amber Nectar, Ceylon Cinnamon',
        base: 'Wild Cambodian Agarwood, Bourbon Vanilla Pod, Smoked Birch Wood'
      },
      description: 'Golden resins simmered over wild agarwood — pure warmth, nobility, and timeless regal presence. Non-staining formulation blended with IFRA compliant natural absolutes.',
      image: 'niamal-amber-al-oud-eau-de-parfum-main-packshot-800w.webp'
    },
    violet: {
      id: 'violet',
      title: 'Violet Oud Eau de Parfum',
      subtitle: 'Eau de Parfum • 50ml',
      arabic: 'نيمال • عود بنفسجي',
      family: 'Midnight Floral • Rare Harvest',
      tag: 'Rare Harvest',
      rating: '4.7',
      reviewsCount: 164,
      basePrice: 799,
      mrp: 999,
      sizes: {
        '30ml': 499,
        '50ml': 799,
        '100ml': 1299
      },
      category: ['unisex', 'for_women', 'best_sellers'],
      scentFamily: ['floral', 'woody', 'oriental'],
      notes: {
        top: 'Night-Blooming Violet Petals, Wild Florentine Iris, Mandarin Dew',
        heart: 'Velvety Violet Leaves, Rare Indonesian Agarwood, Smoked Cashmere',
        base: 'Dark Patchouli Heart, Smoky Birch Tar, Warm Tonka Bean'
      },
      description: 'The elusive harmony between fragile night-blooming violet petals and dark royal agarwood. Ethereal, mysterious, and beautifully layered.',
      image: 'niamal-violet-oud-eau-de-parfum-main-packshot-800w.webp'
    },
    royale: {
      id: 'royale',
      title: 'Oud Royale Pure Attar',
      subtitle: '100% Oil-Based Perfume • 50ml',
      arabic: 'نيمال • عود ملكي',
      family: 'Pure Kalakassi Attar • Single Cask',
      tag: 'Private Reserve',
      rating: '4.9',
      reviewsCount: 142,
      basePrice: 799,
      mrp: 999,
      sizes: {
        '30ml': 499,
        '50ml': 799,
        '100ml': 1299
      },
      category: ['unisex', 'for_men', 'pure_attars'],
      scentFamily: ['woody', 'oriental', 'spicy'],
      notes: {
        top: 'Single-Cask Kalakassi Agarwood, Fresh Grated Nutmeg',
        heart: 'Vintage Suede Leather, Smoked Cedar, Animalic Warm Musk',
        base: 'Pure Concentrated Dehn Al Oud, Earthy Amber, Aged Oakmoss'
      },
      description: '100% alcohol-free concentrated perfume oil. A single drop behind each ear radiates with noble intimacy for more than 24 hours.',
      image: 'niamal-oud-royale-oil-based-perfume-main-packshot-800w.webp'
    },
    floret: {
      id: 'floret',
      title: 'Floret Artisanal Extrait',
      subtitle: 'Artisanal Perfume Oil • 50ml',
      arabic: 'نيمال • فلوريت',
      family: 'Blooming Magnolia & Lily',
      tag: 'Floral Nectar',
      rating: '4.8',
      reviewsCount: 185,
      basePrice: 799,
      mrp: 999,
      sizes: {
        '30ml': 499,
        '50ml': 799,
        '100ml': 1299
      },
      category: ['for_women', 'unisex', 'pure_attars', 'best_sellers'],
      scentFamily: ['floral', 'oriental'],
      notes: {
        top: 'Pink Blooming Magnolia, Sweet Neroli Dew, Italian Bergamot',
        heart: 'Casablanca White Lily, Fresh Peony Petals, Night Jasmine',
        base: 'Soft Sweet Dehn Al Oud, Cashmeran, Golden Ambergris'
      },
      description: 'Morning dew on Casablanca lilies and pink magnolia, warmed by the gentlest kiss of sweet dehn al oud. Luminous, graceful, and enchanting.',
      image: 'niamal-floret-oil-based-perfume-main-packshot-800w.webp'
    }
  };

  // State Management
  let cart = [];
  let wishlist = [];
  const FREE_SHIPPING_THRESHOLD = 999; // INR ₹999 for free pan-India courier

  // Load from LocalStorage
  try {
    const savedCart = localStorage.getItem('niamal_athena_cart');
    if (savedCart) cart = JSON.parse(savedCart);
    const savedWish = localStorage.getItem('niamal_athena_wishlist');
    if (savedWish) wishlist = JSON.parse(savedWish);
  } catch (e) {
    console.warn('LocalStorage unavailable:', e);
  }

  function saveState() {
    try {
      localStorage.setItem('niamal_athena_cart', JSON.stringify(cart));
      localStorage.setItem('niamal_athena_wishlist', JSON.stringify(wishlist));
    } catch (e) {}
  }

  function resolveAssetUrl(filename) {
    if (!filename) return '';
    if (window.AthenaAssetUrls && window.AthenaAssetUrls[filename]) {
      return window.AthenaAssetUrls[filename];
    }
    if (filename.startsWith('http') || filename.startsWith('//') || filename.startsWith('/') || filename.startsWith('../')) return filename;
    return '../assets/' + filename;
  }

  // Master Shopify Real Variant Mapping for Production Deployment
  const SHOPIFY_VARIANT_MAP = {
    'layali': { '30ml': 59206441173256, '50ml': 59206441173256, '100ml': 59206441173256 },
    'royale': { '30ml': 59199633391880, '50ml': 59199633391880, '100ml': 59199633391880 },
    'amber': { '30ml': 59206441763080, '50ml': 59206441795848, '100ml': 59206441828616 },
    'violet': { '30ml': 59206441992456, '50ml': 59206442025224, '100ml': 59206442057992 },
    'floret': { '6ml': 59206442385672, '12ml': 59206442418440, '50ml': 59206442385672 }
  };

  const isShopify = typeof window !== 'undefined' && (
    window.Shopify !== undefined || 
    window.location.hostname.includes('myshopify.com') ||
    window.location.pathname.includes('/products/') ||
    window.location.pathname.includes('/cart')
  );

  function syncWithShopifyCart() {
    if (!isShopify) return;
    fetch('/cart.js')
      .then(res => res.json())
      .then(cartData => {
        if (cartData && Array.isArray(cartData.items) && cartData.items.length > 0) {
          cart = cartData.items.map(item => ({
            id: item.handle || String(item.product_id),
            variantId: item.variant_id,
            lineKey: item.key,
            title: item.product_title || item.title,
            size: item.variant_title || '50ml',
            price: Math.round(item.price / 100),
            image: item.featured_image?.url || 'niamal-layali-eau-de-parfum-main-packshot-800w.webp',
            qty: item.quantity
          }));
          saveState();
          renderCart();
        }
      })
      .catch(() => {});
  }

  // 1. Cart Management (Online Store 2.0 & AJAX Cart API)
  function addToCart(productId, size = '50ml', qty = 1) {
    const prod = ATHENA_CATALOG[productId];
    if (!prod) return;

    const price = prod.sizes[size] || prod.basePrice;
    const existing = cart.find(item => item.id === productId && item.size === size);

    if (existing) {
      existing.qty += qty;
    } else {
      cart.push({
        id: productId,
        title: prod.title,
        size: size,
        price: price,
        image: prod.image,
        qty: qty
      });
    }

    saveState();
    renderCart();
    openCartDrawer();
    showToast(`Added ${prod.title} (${size}) to Bag!`);

    if (isShopify) {
      const variantId = SHOPIFY_VARIANT_MAP[productId]?.[size] || SHOPIFY_VARIANT_MAP[productId]?.['50ml'];
      if (variantId) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
        }).then(() => {
          syncWithShopifyCart();
        }).catch(err => console.warn('Shopify Cart add:', err));
      }
    }
  }

  function updateCartQty(productId, size, change) {
    const item = cart.find(i => i.id === productId && i.size === size);
    if (!item) return;

    item.qty += change;
    const newQty = item.qty;
    if (item.qty <= 0) {
      cart = cart.filter(i => !(i.id === productId && i.size === size));
    }

    saveState();
    renderCart();

    if (isShopify) {
      const variantId = item.variantId || SHOPIFY_VARIANT_MAP[productId]?.[size] || SHOPIFY_VARIANT_MAP[productId]?.['50ml'];
      if (variantId) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: String(variantId), quantity: Math.max(0, newQty) })
        }).then(() => {
          syncWithShopifyCart();
        }).catch(() => {});
      }
    }
  }

  function removeCartItem(productId, size) {
    const item = cart.find(i => i.id === productId && i.size === size);
    cart = cart.filter(i => !(i.id === productId && i.size === size));
    saveState();
    renderCart();

    if (isShopify && item) {
      const variantId = item.variantId || SHOPIFY_VARIANT_MAP[productId]?.[size] || SHOPIFY_VARIANT_MAP[productId]?.['50ml'];
      if (variantId) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: String(variantId), quantity: 0 })
        }).then(() => {
          syncWithShopifyCart();
        }).catch(() => {});
      }
    }
  }

  function renderCart() {
    const cartItemsContainer = document.getElementById('athenaCartItemsList');
    const badgeEl = document.getElementById('athenaCartBadge');
    const bottomNavBadge = document.getElementById('athenaBottomNavCartBadge');
    const subtotalEl = document.getElementById('athenaCartSubtotal');
    const totalEl = document.getElementById('athenaCartTotal');
    const shippingMsg = document.getElementById('athenaShippingMsg');
    const progressFill = document.getElementById('athenaShippingProgressFill');

    const totalQty = cart.reduce((sum, item) => sum + item.qty, 0);
    const subtotal = cart.reduce((sum, item) => sum + (item.price * item.qty), 0);

    if (badgeEl) {
      badgeEl.textContent = totalQty;
      badgeEl.style.display = totalQty > 0 ? 'flex' : 'none';
    }
    if (bottomNavBadge) {
      bottomNavBadge.textContent = totalQty;
      bottomNavBadge.style.display = totalQty > 0 ? 'flex' : 'none';
    }

    const headerCartText = document.getElementById('athenaHeaderCartText');
    if (headerCartText) {
      headerCartText.textContent = totalQty > 0 ? `Bag (${totalQty}) • ₹${subtotal.toLocaleString('en-IN')}` : 'Bag';
    }

    if (subtotalEl) subtotalEl.textContent = `₹${subtotal.toLocaleString('en-IN')}`;
    if (totalEl) totalEl.textContent = `₹${subtotal.toLocaleString('en-IN')}`;

    // Free delivery calculation
    if (progressFill && shippingMsg) {
      if (subtotal >= FREE_SHIPPING_THRESHOLD) {
        progressFill.style.width = '100%';
        shippingMsg.innerHTML = '🎉 <strong>FREE Pan-India Delivery Unlocked!</strong>';
      } else {
        const remaining = FREE_SHIPPING_THRESHOLD - subtotal;
        const pct = Math.min(Math.round((subtotal / FREE_SHIPPING_THRESHOLD) * 100), 100);
        progressFill.style.width = pct + '%';
        shippingMsg.innerHTML = `🚚 Add <strong>₹${remaining.toLocaleString('en-IN')}</strong> more for FREE Delivery!`;
      }
    }

    if (!cartItemsContainer) return;

    if (cart.length === 0) {
      cartItemsContainer.innerHTML = `
        <div style="text-align: center; padding: 4rem 1rem; color: var(--athena-text-muted);">
          <div style="font-size: 3.5rem; margin-bottom: 1rem;">🛍</div>
          <h3 style="color: #FFFFFF; font-family: var(--athena-font-serif); margin-bottom: 0.5rem;">Your Cart is Empty</h3>
          <p style="font-size: 1.25rem;">Discover our artisanal extrait formulations crafted for enduring presence.</p>
        </div>
      `;
      return;
    }

    cartItemsContainer.innerHTML = cart.map(item => `
      <div class="athena-cart-item">
        <div class="athena-cart-item-thumb">
          <img src="${resolveAssetUrl(item.image)}" alt="${item.title}" loading="lazy" width="60" height="60">
        </div>
        <div class="athena-cart-item-details">
          <div>
            <h4 class="athena-cart-item-title">${item.title}</h4>
            <div class="athena-cart-item-sub">Extrait de Parfum • ${item.size}</div>
          </div>
          <div class="athena-cart-item-bottom">
            <div class="athena-stepper">
              <button type="button" class="athena-stepper-btn" onclick="window.NiamalAthena.updateCartQty('${item.id}', '${item.size}', -1)">&minus;</button>
              <span class="athena-stepper-val">${item.qty}</span>
              <button type="button" class="athena-stepper-btn" onclick="window.NiamalAthena.updateCartQty('${item.id}', '${item.size}', 1)">&plus;</button>
            </div>
            <div class="athena-cart-item-price">₹${(item.price * item.qty).toLocaleString('en-IN')}</div>
          </div>
        </div>
        <button type="button" onclick="window.NiamalAthena.removeCartItem('${item.id}', '${item.size}')" style="background: transparent; border: none; color: var(--athena-text-subtle); cursor: pointer; padding: 4px;" aria-label="Remove item">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
        </button>
      </div>
    `).join('');
  }

  // 2. Wishlist Management
  function toggleWishlist(productId) {
    const idx = wishlist.indexOf(productId);
    if (idx > -1) {
      wishlist.splice(idx, 1);
      showToast(`Removed from Wishlist`);
    } else {
      wishlist.push(productId);
      showToast(`Saved to Wishlist!`);
    }
    saveState();
    renderWishlist();
    updateCardWishlistHearts();
  }

  function updateCardWishlistHearts() {
    document.querySelectorAll('.athena-wishlist-toggle').forEach(btn => {
      const pid = btn.getAttribute('data-product-id');
      const isFav = wishlist.includes(pid);
      btn.classList.toggle('is-active', isFav);
      btn.innerHTML = isFav 
        ? '<svg width="17" height="17" viewBox="0 0 24 24" fill="#FFFFFF" stroke="#FFFFFF" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>'
        : '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>';
    });

    const badge = document.getElementById('athenaWishlistBadge');
    if (badge) {
      badge.textContent = wishlist.length;
      badge.style.display = wishlist.length > 0 ? 'flex' : 'none';
    }
  }

  function renderWishlist() {
    const container = document.getElementById('athenaWishlistItemsList');
    if (!container) return;

    if (wishlist.length === 0) {
      container.innerHTML = `
        <div style="text-align: center; padding: 4rem 1rem; color: var(--athena-text-muted);">
          <div style="font-size: 3.5rem; margin-bottom: 1rem;">♡</div>
          <h3 style="color: #FFFFFF; font-family: var(--athena-font-serif); margin-bottom: 0.5rem;">Your Wishlist is Empty</h3>
          <p style="font-size: 1.25rem;">Tap the heart icon on any perfume to save your favorites.</p>
        </div>
      `;
      return;
    }

    container.innerHTML = wishlist.map(pid => {
      const prod = ATHENA_CATALOG[pid];
      if (!prod) return '';
      return `
        <div class="athena-cart-item">
          <div class="athena-cart-item-thumb">
            <img src="${resolveAssetUrl(prod.image)}" alt="${prod.title}" loading="lazy" width="60" height="60">
          </div>
          <div class="athena-cart-item-details">
            <div>
              <h4 class="athena-cart-item-title">${prod.title}</h4>
              <div class="athena-cart-item-sub">${prod.family}</div>
            </div>
            <div class="athena-cart-item-bottom">
              <div class="athena-cart-item-price">₹${prod.basePrice.toLocaleString('en-IN')}</div>
              <button type="button" class="athena-cat-pill" style="padding: 6px 12px; font-size: 1.15rem;" onclick="window.NiamalAthena.addToCart('${prod.id}', '50ml', 1)">
                Add to Cart
              </button>
            </div>
          </div>
          <button type="button" onclick="window.NiamalAthena.toggleWishlist('${prod.id}')" style="background: transparent; border: none; color: #E53935; cursor: pointer; padding: 4px;" aria-label="Remove from wishlist">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="#E53935" stroke="#E53935" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>
          </button>
        </div>
      `;
    }).join('');
  }

  function moveAllWishlistToCart() {
    wishlist.forEach(pid => {
      addToCart(pid, '50ml', 1);
    });
    wishlist = [];
    saveState();
    renderWishlist();
    updateCardWishlistHearts();
    closeWishlistModal();
    openCartDrawer();
  }

  // 3. Interactive PDP Quick-View Modal
  let activePdpProduct = 'layali';
  let activePdpSize = '50ml';

  function openPdpModal(productId) {
    const prod = ATHENA_CATALOG[productId];
    if (!prod) return;

    activePdpProduct = productId;
    activePdpSize = '50ml';

    const dialog = document.getElementById('athenaPdpDialog');
    const overlay = document.getElementById('athenaModalOverlay');
    if (!dialog || !overlay) return;

    // Populate Dialog Elements
    const titleEl = document.getElementById('athenaPdpTitle');
    const subEl = document.getElementById('athenaPdpSub');
    const priceEl = document.getElementById('athenaPdpPrice');
    const mrpEl = document.getElementById('athenaPdpMrp');
    const imgEl = document.getElementById('athenaPdpImg');
    const descEl = document.getElementById('athenaPdpDesc');
    const notesTopEl = document.getElementById('athenaPdpNotesTop');
    const notesHeartEl = document.getElementById('athenaPdpNotesHeart');
    const notesBaseEl = document.getElementById('athenaPdpNotesBase');

    if (titleEl) titleEl.textContent = prod.title;
    if (subEl) subEl.textContent = `${prod.family} • Handcrafted for Indian Sillage`;
    if (priceEl) priceEl.textContent = `₹${prod.basePrice.toLocaleString('en-IN')}`;
    if (mrpEl) mrpEl.textContent = `₹${prod.mrp.toLocaleString('en-IN')} (20% OFF)`;
    if (imgEl) {
      imgEl.src = resolveAssetUrl(prod.image);
      imgEl.alt = prod.title;
    }
    if (descEl) descEl.textContent = prod.description;
    if (notesTopEl) notesTopEl.textContent = prod.notes.top;
    if (notesHeartEl) notesHeartEl.textContent = prod.notes.heart;
    if (notesBaseEl) notesBaseEl.textContent = prod.notes.base;

    // Reset size buttons
    document.querySelectorAll('.athena-size-pill').forEach(btn => {
      const s = btn.getAttribute('data-size');
      btn.classList.toggle('is-active', s === '50ml');
    });

    overlay.classList.add('is-active');
    dialog.classList.add('is-active');
  }

  function setPdpSize(size) {
    activePdpSize = size;
    const prod = ATHENA_CATALOG[activePdpProduct];
    if (!prod) return;

    const price = prod.sizes[size] || prod.basePrice;
    const priceEl = document.getElementById('athenaPdpPrice');
    if (priceEl) priceEl.textContent = `₹${price.toLocaleString('en-IN')}`;

    document.querySelectorAll('.athena-size-pill').forEach(btn => {
      btn.classList.toggle('is-active', btn.getAttribute('data-size') === size);
    });
  }

  function closePdpModal() {
    const dialog = document.getElementById('athenaPdpDialog');
    const overlay = document.getElementById('athenaModalOverlay');
    if (dialog) dialog.classList.remove('is-active');
    if (overlay && !isCartOpen && !isCheckoutOpen && !isWishlistOpen) {
      overlay.classList.remove('is-active');
    }
  }

  // 4. Modal Toggles
  let isCartOpen = false;
  let isWishlistOpen = false;
  let isCheckoutOpen = false;

  function openCartDrawer() {
    closePdpModal();
    closeWishlistModal();
    closeCheckoutModal();
    const drawer = document.getElementById('athenaCartDrawer');
    const overlay = document.getElementById('athenaModalOverlay');
    if (drawer) drawer.classList.add('is-active');
    if (overlay) overlay.classList.add('is-active');
    isCartOpen = true;
  }

  function closeCartDrawer() {
    const drawer = document.getElementById('athenaCartDrawer');
    const overlay = document.getElementById('athenaModalOverlay');
    if (drawer) drawer.classList.remove('is-active');
    if (overlay && !isCheckoutOpen && !isWishlistOpen) overlay.classList.remove('is-active');
    isCartOpen = false;
  }

  function openWishlistModal() {
    closeCartDrawer();
    closePdpModal();
    renderWishlist();
    const drawer = document.getElementById('athenaWishlistDrawer');
    const overlay = document.getElementById('athenaModalOverlay');
    if (drawer) drawer.classList.add('is-active');
    if (overlay) overlay.classList.add('is-active');
    isWishlistOpen = true;
  }

  function closeWishlistModal() {
    const drawer = document.getElementById('athenaWishlistDrawer');
    const overlay = document.getElementById('athenaModalOverlay');
    if (drawer) drawer.classList.remove('is-active');
    if (overlay && !isCartOpen && !isCheckoutOpen) overlay.classList.remove('is-active');
    isWishlistOpen = false;
  }

  // 5. India Checkout Flow
  const INDIA_PINCODES = {
    '400001': { city: 'Mumbai', state: 'Maharashtra' },
    '110001': { city: 'New Delhi', state: 'Delhi' },
    '560001': { city: 'Bengaluru', state: 'Karnataka' },
    '600001': { city: 'Chennai', state: 'Tamil Nadu' },
    '500001': { city: 'Hyderabad', state: 'Telangana' },
    '700001': { city: 'Kolkata', state: 'West Bengal' },
    '380001': { city: 'Ahmedabad', state: 'Gujarat' },
    '411001': { city: 'Pune', state: 'Maharashtra' },
    '302001': { city: 'Jaipur', state: 'Rajasthan' },
    '226001': { city: 'Lucknow', state: 'Uttar Pradesh' }
  };

  function openCheckoutModal() {
    if (cart.length === 0) {
      showToast('Your cart is empty');
      return;
    }
    closeCartDrawer();
    const dialog = document.getElementById('athenaCheckoutDialog');
    const overlay = document.getElementById('athenaModalOverlay');

    const subtotal = cart.reduce((sum, item) => sum + (item.price * item.qty), 0);
    const shipping = subtotal >= FREE_SHIPPING_THRESHOLD ? 0 : 50;
    const total = subtotal + shipping;

    const summarySubtotal = document.getElementById('checkoutSummarySubtotal');
    const summaryShipping = document.getElementById('checkoutSummaryShipping');
    const summaryTotal = document.getElementById('checkoutSummaryTotal');
    const ctaTotal = document.getElementById('checkoutCtaTotal');

    if (summarySubtotal) summarySubtotal.textContent = `₹${subtotal.toLocaleString('en-IN')}`;
    if (summaryShipping) summaryShipping.textContent = shipping === 0 ? 'FREE' : `₹${shipping}`;
    if (summaryTotal) summaryTotal.textContent = `₹${total.toLocaleString('en-IN')}`;
    if (ctaTotal) ctaTotal.textContent = `₹${total.toLocaleString('en-IN')}`;

    if (dialog) dialog.classList.add('is-active');
    if (overlay) overlay.classList.add('is-active');
    isCheckoutOpen = true;
  }

  function closeCheckoutModal() {
    const dialog = document.getElementById('athenaCheckoutDialog');
    const overlay = document.getElementById('athenaModalOverlay');
    if (dialog) dialog.classList.remove('is-active');
    if (overlay) overlay.classList.remove('is-active');
    isCheckoutOpen = false;
  }

  function lookupPincode(pincode) {
    const clean = pincode.trim();
    const cityInput = document.getElementById('checkoutCity');
    const stateInput = document.getElementById('checkoutState');
    if (INDIA_PINCODES[clean]) {
      if (cityInput) cityInput.value = INDIA_PINCODES[clean].city;
      if (stateInput) stateInput.value = INDIA_PINCODES[clean].state;
    }
  }

  function placeOrder() {
    const name = document.getElementById('checkoutName')?.value || 'Valued Client';
    const phone = document.getElementById('checkoutPhone')?.value || '+91 98200 00000';
    const pincode = document.getElementById('checkoutPincode')?.value || '400001';
    const city = document.getElementById('checkoutCity')?.value || 'Mumbai';

    const orderNum = 'NL-IND-' + Math.floor(100000 + Math.random() * 900000);
    const subtotal = cart.reduce((sum, item) => sum + (item.price * item.qty), 0);

    const dialog = document.getElementById('athenaCheckoutDialog');
    if (dialog) {
      dialog.innerHTML = `
        <div style="text-align: center; padding: 2rem 1rem;">
          <div style="width: 72px; height: 72px; background: rgba(214, 123, 128, 0.2); border: 2px solid var(--athena-coral-accent); border-radius: 50%; display: flex; align-items: center; justify-content: center; margin: 0 auto 1.5rem; color: var(--athena-coral-accent); font-size: 2.4rem;">
            ✓
          </div>
          <h2 style="font-family: var(--athena-font-serif); font-size: 2.6rem; color: #FFFFFF; margin-bottom: 0.5rem;">Order Confirmed!</h2>
          <div style="font-size: 1.35rem; color: var(--athena-coral-accent); font-weight: 700; margin-bottom: 1.5rem;">Order ID: #${orderNum}</div>
          <p style="font-size: 1.35rem; color: var(--athena-cream-silk); line-height: 1.6; max-width: 440px; margin: 0 auto 2rem;">
            Thank you, <strong>${name}</strong>. Your artisanal allocation has been reserved. Dispatched via express insured courier with real-time tracking sent to <strong>${phone}</strong>.
          </p>
          <div style="background: rgba(43, 18, 21, 0.7); border: 1px solid var(--athena-border-subtle); border-radius: 12px; padding: 1.4rem; text-align: left; margin-bottom: 2rem; font-size: 1.3rem;">
            <div style="display: flex; justify-content: space-between; margin-bottom: 6px;">
              <span>Destination:</span>
              <span style="color: #FFFFFF; font-weight: 600;">${city} (${pincode})</span>
            </div>
            <div style="display: flex; justify-content: space-between; margin-bottom: 6px;">
              <span>Courier Partner:</span>
              <span style="color: var(--athena-coral-accent); font-weight: 600;">BlueDart Express Air</span>
            </div>
            <div style="display: flex; justify-content: space-between; margin-bottom: 6px;">
              <span>Estimated Delivery:</span>
              <span style="color: #FFFFFF; font-weight: 600;">3 &ndash; 5 Business Days</span>
            </div>
            <div style="display: flex; justify-content: space-between; border-top: 1px solid rgba(214, 123, 128, 0.15); padding-top: 8px; margin-top: 8px; font-weight: 700;">
              <span>Amount Paid:</span>
              <span style="color: var(--athena-coral-accent);">₹${subtotal.toLocaleString('en-IN')}</span>
            </div>
          </div>
          <button type="button" class="athena-btn-checkout" onclick="window.NiamalAthena.closeCheckoutModal(); window.location.reload();">
            Continue Shopping
          </button>
        </div>
      `;
    }

    // Clear cart
    cart = [];
    saveState();
    renderCart();
  }

  // 6. Filtering & Search
  function filterCategory(catKey) {
    document.querySelectorAll('.athena-cat-pill').forEach(btn => {
      btn.classList.toggle('is-active', btn.getAttribute('data-category') === catKey);
    });

    const cards = document.querySelectorAll('.athena-product-card');
    cards.forEach(card => {
      const pid = card.getAttribute('data-product-id');
      const prod = ATHENA_CATALOG[pid];
      if (!prod) return;

      if (catKey === 'all' || prod.category.includes(catKey)) {
        card.style.display = 'flex';
      } else {
        card.style.display = 'none';
      }
    });
  }

  function filterScent(scentKey) {
    document.querySelectorAll('.athena-scent-chip').forEach(chip => {
      const isTarget = chip.getAttribute('data-scent') === scentKey;
      chip.classList.toggle('is-selected', isTarget);
    });

    const cards = document.querySelectorAll('.athena-product-card');
    cards.forEach(card => {
      const pid = card.getAttribute('data-product-id');
      const prod = ATHENA_CATALOG[pid];
      if (!prod) return;

      if (scentKey === 'all' || prod.scentFamily.includes(scentKey)) {
        card.style.display = 'flex';
      } else {
        card.style.display = 'none';
      }
    });
  }

  function handleSearch(query) {
    const q = query.trim().toLowerCase();
    const cards = document.querySelectorAll('.athena-product-card');

    cards.forEach(card => {
      const pid = card.getAttribute('data-product-id');
      const prod = ATHENA_CATALOG[pid];
      if (!prod) return;

      const searchable = (prod.title + ' ' + prod.family + ' ' + prod.notes.top + ' ' + prod.notes.heart + ' ' + prod.notes.base).toLowerCase();
      if (!q || searchable.includes(q)) {
        card.style.display = 'flex';
      } else {
        card.style.display = 'none';
      }
    });
  }

  // 7. Device Viewport Mode Toggle (App View vs Web View)
  function setDeviceMode(mode) {
    const wrapper = document.getElementById('athenaViewportWrapper');
    const btnApp = document.getElementById('btnModeApp');
    const btnWeb = document.getElementById('btnModeWeb');

    if (mode === 'app') {
      if (wrapper) wrapper.classList.add('is-phone-mockup');
      if (btnApp) btnApp.classList.add('is-active');
      if (btnWeb) btnWeb.classList.remove('is-active');
    } else {
      if (wrapper) wrapper.classList.remove('is-phone-mockup');
      if (btnWeb) btnWeb.classList.add('is-active');
      if (btnApp) btnApp.classList.remove('is-active');
    }
  }

  // 8. Toast Notification
  function showToast(msg) {
    let toast = document.getElementById('athenaToast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'athenaToast';
      toast.style.cssText = `
        position: fixed;
        bottom: 75px;
        left: 50%;
        transform: translateX(-50%) translateY(20px);
        background: rgba(46, 18, 22, 0.95);
        border: 1px solid var(--athena-coral-accent);
        color: #FFFFFF;
        padding: 10px 20px;
        border-radius: 9999px;
        font-size: 1.3rem;
        font-weight: 600;
        z-index: 99999;
        box-shadow: 0 10px 25px rgba(0,0,0,0.6);
        pointer-events: none;
        opacity: 0;
        transition: all 0.3s ease;
      `;
      document.body.appendChild(toast);
    }
    toast.textContent = msg;
    toast.style.opacity = '1';
    toast.style.transform = 'translateX(-50%) translateY(0)';
    setTimeout(() => {
      toast.style.opacity = '0';
      toast.style.transform = 'translateX(-50%) translateY(20px)';
    }, 2400);
  }

  // 9. Master Initialization
  function initAthena() {
    renderCart();
    updateCardWishlistHearts();
    syncWithShopifyCart();

    // Bind Search Inputs (Both Desktop and Mobile)
    const searchInput = document.getElementById('athenaSearchInput');
    const desktopSearchInput = document.getElementById('athenaDesktopSearchInput');
    if (searchInput) {
      searchInput.addEventListener('input', e => handleSearch(e.target.value));
    }
    if (desktopSearchInput) {
      desktopSearchInput.addEventListener('input', e => handleSearch(e.target.value));
    }

    // Bind Pincode Lookup
    const pincodeInput = document.getElementById('checkoutPincode');
    if (pincodeInput) {
      pincodeInput.addEventListener('input', e => {
        if (e.target.value.length === 6) lookupPincode(e.target.value);
      });
    }

    // Bind Accordions
    document.querySelectorAll('.athena-accordion-header').forEach(hdr => {
      hdr.addEventListener('click', function() {
        this.parentElement.classList.toggle('is-open');
      });
    });

    // Close overlays on outside click
    const overlay = document.getElementById('athenaModalOverlay');
    if (overlay) {
      overlay.addEventListener('click', () => {
        closeCartDrawer();
        closeWishlistModal();
        closePdpModal();
        closeCheckoutModal();
      });
    }
  }

  // Global Controller Export
  window.NiamalAthena = {
    addToCart,
    updateCartQty,
    removeCartItem,
    toggleWishlist,
    moveAllWishlistToCart,
    openPdpModal,
    setPdpSize,
    closePdpModal,
    openCartDrawer,
    closeCartDrawer,
    openWishlistModal,
    closeWishlistModal,
    openCheckoutModal,
    closeCheckoutModal,
    placeOrder,
    filterCategory,
    filterScent,
    setDeviceMode,
    syncWithShopifyCart,
    showToast
  };

  // Safe Execution Guard
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAthena);
  } else {
    initAthena();
  }
})();
